export default {
  pt: {
    'shipments.historicoConjuntoDialog.title': 'Histórico de status',
    'shipments.historicoConjuntoDialog.noStatus': 'Sem status',
    'shipments.historicoConjuntoDialog.empty': 'Sem eventos para este conjunto.',
    'shipments.historicoConjuntoDialog.system': 'Sistema',
    'shipments.historicoConjuntoDialog.contract': 'Contrato',
    'shipments.historicoConjuntoDialog.dayOffUntil': 'Folga até',
    'shipments.historicoConjuntoDialog.unloadingLocation': 'Local de descarga',
    'shipments.historicoConjuntoDialog.status.advancing': 'Adiantando',
    'shipments.historicoConjuntoDialog.tabStatus': 'Status',
    'shipments.historicoConjuntoDialog.tabAvailable': 'Último Disponível',
    'shipments.historicoConjuntoDialog.emptyAvailable': 'Nenhum Disponível registrado depois de uma operação.',
    'shipments.historicoConjuntoDialog.current': 'Vigente',
    'shipments.historicoConjuntoDialog.cameFrom': 'Saiu de',
    'shipments.historicoConjuntoDialog.previousRecord': 'Registro anterior a 22/09/2026',
    'shipments.historicoConjuntoDialog.trip': 'Viagem',
    'shipments.historicoConjuntoDialog.enteredBy': 'Lançado por',
    'shipments.historicoConjuntoDialog.enteredAt': 'Lançado em',
    'shipments.historicoConjuntoDialog.correction': 'Correção',
    'shipments.historicoConjuntoDialog.before': 'Antes',
    'shipments.historicoConjuntoDialog.after': 'Depois',
    'shipments.historicoConjuntoDialog.by': 'Por',
    'shipments.historicoConjuntoDialog.at': 'Em',
    'shipments.historicoConjuntoDialog.status.available': 'Disponível',
    'shipments.historicoConjuntoDialog.status.scheduled': 'Escalado',
    'shipments.historicoConjuntoDialog.status.loading': 'Carregando',
    'shipments.historicoConjuntoDialog.status.transit': 'Em trânsito',
    'shipments.historicoConjuntoDialog.status.unloading': 'Descarregando',
    'shipments.historicoConjuntoDialog.status.maintenance': 'Manutenção',
    'shipments.historicoConjuntoDialog.status.dayOff': 'Folga',
    'shipments.historicoConjuntoDialog.status.otherProgram': 'Outros Serviços',
    'shipments.historicoConjuntoDialog.status.operators': 'Operadores',
    'shipments.historicoConjuntoDialog.status.away': 'Afastado',
  },
  en: {
    'shipments.historicoConjuntoDialog.title': 'Status history',
    'shipments.historicoConjuntoDialog.noStatus': 'No status',
    'shipments.historicoConjuntoDialog.empty': 'No events for this set.',
    'shipments.historicoConjuntoDialog.system': 'System',
    'shipments.historicoConjuntoDialog.contract': 'Contract',
    'shipments.historicoConjuntoDialog.dayOffUntil': 'Day off until',
    'shipments.historicoConjuntoDialog.unloadingLocation': 'Unloading location',
    'shipments.historicoConjuntoDialog.status.advancing': 'Sent ahead',
    'shipments.historicoConjuntoDialog.tabStatus': 'Status',
    'shipments.historicoConjuntoDialog.tabAvailable': 'Last available',
    'shipments.historicoConjuntoDialog.emptyAvailable': 'No availability recorded after an operation.',
    'shipments.historicoConjuntoDialog.current': 'Current',
    'shipments.historicoConjuntoDialog.cameFrom': 'Came from',
    'shipments.historicoConjuntoDialog.previousRecord': 'Record from before 09/22/2026',
    'shipments.historicoConjuntoDialog.trip': 'Trip',
    'shipments.historicoConjuntoDialog.enteredBy': 'Entered by',
    'shipments.historicoConjuntoDialog.enteredAt': 'Entered at',
    'shipments.historicoConjuntoDialog.correction': 'Correction',
    'shipments.historicoConjuntoDialog.before': 'Before',
    'shipments.historicoConjuntoDialog.after': 'After',
    'shipments.historicoConjuntoDialog.by': 'By',
    'shipments.historicoConjuntoDialog.at': 'At',
    'shipments.historicoConjuntoDialog.status.available': 'Available',
    'shipments.historicoConjuntoDialog.status.scheduled': 'Scheduled',
    'shipments.historicoConjuntoDialog.status.loading': 'Loading',
    'shipments.historicoConjuntoDialog.status.transit': 'In transit',
    'shipments.historicoConjuntoDialog.status.unloading': 'Unloading',
    'shipments.historicoConjuntoDialog.status.maintenance': 'Maintenance',
    'shipments.historicoConjuntoDialog.status.dayOff': 'Day off',
    'shipments.historicoConjuntoDialog.status.otherProgram': 'Other Services',
    'shipments.historicoConjuntoDialog.status.operators': 'Operators',
    'shipments.historicoConjuntoDialog.status.away': 'Away',
  },
  es: {
    'shipments.historicoConjuntoDialog.title': 'Historial de estados',
    'shipments.historicoConjuntoDialog.noStatus': 'Sin estado',
    'shipments.historicoConjuntoDialog.empty': 'No hay eventos para este conjunto.',
    'shipments.historicoConjuntoDialog.system': 'Sistema',
    'shipments.historicoConjuntoDialog.contract': 'Contrato',
    'shipments.historicoConjuntoDialog.dayOffUntil': 'Descanso hasta',
    'shipments.historicoConjuntoDialog.unloadingLocation': 'Lugar de descarga',
    'shipments.historicoConjuntoDialog.status.advancing': 'Adelantado',
    'shipments.historicoConjuntoDialog.tabStatus': 'Estado',
    'shipments.historicoConjuntoDialog.tabAvailable': 'Último disponible',
    'shipments.historicoConjuntoDialog.emptyAvailable': 'Ningún disponible registrado después de una operación.',
    'shipments.historicoConjuntoDialog.current': 'Vigente',
    'shipments.historicoConjuntoDialog.cameFrom': 'Salió de',
    'shipments.historicoConjuntoDialog.previousRecord': 'Registro anterior al 22/09/2026',
    'shipments.historicoConjuntoDialog.trip': 'Viaje',
    'shipments.historicoConjuntoDialog.enteredBy': 'Registrado por',
    'shipments.historicoConjuntoDialog.enteredAt': 'Registrado el',
    'shipments.historicoConjuntoDialog.correction': 'Corrección',
    'shipments.historicoConjuntoDialog.before': 'Antes',
    'shipments.historicoConjuntoDialog.after': 'Después',
    'shipments.historicoConjuntoDialog.by': 'Por',
    'shipments.historicoConjuntoDialog.at': 'El',
    'shipments.historicoConjuntoDialog.status.available': 'Disponible',
    'shipments.historicoConjuntoDialog.status.scheduled': 'Programado',
    'shipments.historicoConjuntoDialog.status.loading': 'Cargando',
    'shipments.historicoConjuntoDialog.status.transit': 'En tránsito',
    'shipments.historicoConjuntoDialog.status.unloading': 'Descargando',
    'shipments.historicoConjuntoDialog.status.maintenance': 'Mantenimiento',
    'shipments.historicoConjuntoDialog.status.dayOff': 'Descanso',
    'shipments.historicoConjuntoDialog.status.otherProgram': 'Otros Servicios',
    'shipments.historicoConjuntoDialog.status.operators': 'Operadores',
    'shipments.historicoConjuntoDialog.status.away': 'Ausente',
  },
}
